import React, { useEffect } from "react";
import {
  Select,
  MenuItem,
  FormControl,
} from "@material-ui/core";
import CustomTextField from "../Common/CustomTextField";
import * as actions from "../../containers/User/Dashboard/actions";
import { useDispatch, useSelector } from "react-redux";
import { isSuperAdminLogin } from "../../utils";

const organizationTypes = [
  {
    label: "FSC",
  },
  {
    label: "FOW",
  },
  {
    label: "FMM",
  },
];

function AddNewOrg(props) {
  const { organization = [], onChange = () => { }, isEdit = false } = props;
  const dispatch = useDispatch();
  const {
    domain = "",
    organizationAdmin = "",
    organizationType = "",
    organizationName = "",
  } = organization;
  const { allAdminUsers = [], allAdminUsersLoading } = useSelector(
    (state) => state.dashboard
  );

  useEffect(() => {
    const data = isEdit && { orgId: organization._id, isEditOrg: true } || {};
    isSuperAdminLogin() && dispatch(actions.allAdminUsers(data));
  }, []);

  return (
    <div className="admin-form grid grid-cols-1 gap-3 py-1">
        <div>
          <label htmlFor="organization-name" className="block text-[11px] text-slate-700 mb-1">Organization Name</label>
          <CustomTextField
            id="organization-name"
            placeholder="Enter organization name"
            size="small"
            name="organizationName"
            value={organizationName}
            onChange={onChange}
          />
        </div>
        <div>
          <label htmlFor="organization-domain" className="block text-[11px] text-slate-700 mb-1">Domain Name</label>
          <CustomTextField
            id="organization-domain"
            placeholder="example.com"
            size="small"
            name="domain"
            value={domain}
            onChange={onChange}
          />
        </div>
        {isSuperAdminLogin() && (
          <div>
              <label id="organization-admin-label" className="block text-[11px] text-slate-700 mb-1">Organization Admin</label>
              <FormControl fullWidth variant="outlined" size="small">
                <Select
                  labelId="organization-admin-label"
                  id="organization-admin"
                  value={organizationAdmin}
                  name="organizationAdmin"
                  onChange={onChange}
                  disabled={allAdminUsersLoading}
                  displayEmpty
                  MenuProps={{ classes: { paper: "admin-form-menu" } }}
                >
                  <MenuItem value="" disabled>{allAdminUsersLoading ? "Loading admins..." : "Select an admin"}</MenuItem>
                  {allAdminUsers.length ? allAdminUsers.map((item) => {
                    return (
                      <MenuItem key={item._id} value={item._id}>
                        {item.firstName} {item.lastName}
                      </MenuItem>
                    );
                  }) : <MenuItem disabled>No admins available</MenuItem>}
                </Select>
              </FormControl>
          </div>
        )}
        <div>
          <label id="organization-type-label" className="block text-[11px] text-slate-700 mb-1">Organization Type</label>
          <FormControl fullWidth variant="outlined" size="small">
            <Select
              labelId="organization-type-label"
              id="organization-type"
              value={organizationType}
              name="organizationType"
              onChange={onChange}
              displayEmpty
              MenuProps={{ classes: { paper: "admin-form-menu" } }}
            >
              <MenuItem value="" disabled>Select a type</MenuItem>
              {organizationTypes.map((item) => {
                return (
                  <MenuItem key={item.label} value={item.label}>
                    {item.label}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </div>
    </div>
  );
}

export default AddNewOrg;
